import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@theprelude/ds";
import { useState } from "react";

export function DefaultTooltip({
  children,
  content,
  asChild,
  disabled,
}: {
  children: React.ReactNode;
  content: React.ReactNode;
  asChild?: boolean;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <TooltipProvider>
      <Tooltip
        open={open}
        onOpenChange={(val) => {
          if (val && !disabled) {
            setOpen(true);
          } else {
            setOpen(false);
          }
        }}
      >
        <TooltipTrigger
          asChild={asChild}
          onClick={() => {
            if (document.activeElement instanceof HTMLElement) {
              document.activeElement.blur();
            }
          }}
        >
          {children}
        </TooltipTrigger>
        <TooltipContent>{content}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
